/**
 * Formata um número no formato de moeda BRL
 * @param {string|number} number
 * @param {Intl.NumberFormatOptions} options
 */
export function formatMoney(
  number,
  options = {
    currency: 'BRL',
    style: 'currency',
  }
) {
  return Intl.NumberFormat('pt-BR', options).format(number || 0);
}
